import script from "./MelissaAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./MelissaAddress.vue?vue&type=script&setup=true&lang=js"

import "./MelissaAddress.vue?vue&type=style&index=0&id=e39bf570&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e39bf570"]])

export default __exports__